import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_PROJECT_URL;
const supabaseAnonKey = process.env.REACT_APP_ANON_PUBLIC_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
